import React from "react";
import CustomVideoPlayer from "./CustomVideoPlayer";
// import "./ReviewPage.css";  Make sure to import the CSS

const ReviewPage = () => {
  return (
    <div className=" w-full h-[calc(100vh-58px)]" > 
      <div className="bg-black flex-grow relative w-full h-full">
        <CustomVideoPlayer /> {/* Your custom video player */}
      </div>
    </div>
  );
};

export default ReviewPage;
